import { Component, OnInit } from '@angular/core';
import { AppContainerOptions, AppContainerService, IAppContainerFrame } from '@mydocma/app-container';
import { environment } from '../../environments/environment';
import { MediatorService } from '@mydocma/core';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css'],
  providers: [
    AppContainerService,
    AppContainerOptions,
],
})
export class MainComponent implements OnInit, IAppContainerFrame {

  public needsSync = false;

  constructor(
    public options: AppContainerOptions,
    private appContainerService: AppContainerService,
    private mediator: MediatorService
  ) {
    this.appContainerService.notifyChanges((appcontainer) => {
      appcontainer.appIcon.name = environment.appName;
      appcontainer.appIcon.color = environment.appIconColor;
    });
    this.mediator.subscribe("sync-state", this, (publisher, data) => {
      this.needsSync = data;
    });
  }
  acOnRegister(appContainer: AppContainerOptions) {


    // buttons.push(new LinkSideNavButton({id: 'pix3', text: 'Help', url: '/pix/help'}));
    // appContainer.sideNavBar.buttons = buttons;
  }

  acOnUnregister(appContainer: AppContainerOptions) {
    appContainer.sideNavBar.buttons = [];
    appContainer.topActionsBar.buttons = [];
  }

  ngOnInit() {
  }

}
